import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  contentWrapper: {
    border: `1px solid ${theme.palette.grey[300]}`,
    marginBottom: '0px',
    minHeight: '20px',
    display: 'flex',
    flexDirection: 'column',
    '& .subContentWrapper': {
      display: 'flex',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
      },
      '& .MuiCheckbox-root': {
        padding: '1px 8px',
      },
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },
  },
  divider: {
    stroke: theme.new.color.line.hairline,
    strokeWidth: '1px',
    height: '20px',
  },
  filterLabel: {
    fontFamily: 'Inter, "Open Sans", Arial, sans-serif',
    fontWeight: 500,
    backgroundColor: theme.palette.grey[200],
    width: '28%',
    padding: '16px 10px',
    [theme.breakpoints.down('md')]: {
      padding: '8px',
      width: '100%',
    },
  },
  filterOptions: {
    width: '72%',
    padding: '16px 16px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      '& > label': {
        width: '48%',
      },
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '8px 8px 16px',
    },
  },
  truncatedFilterOptionLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '178px',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '15px',
  },

  // accordion styles
  accordionContainer: {
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      width: '372px',
    },
    [theme.breakpoints.up('md')]: {
      width: '450px',
    },
    '& .MuiPaper-root': {
      backgroundColor: theme.new.color.common.white,
      boxShadow: 'none',
    },
  },
  filterContent: {
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  filterAccordion: {
    minHeight: 'unset',
    borderBottom: `1px solid ${theme.new.color.line.hairline}`,

    '&:last-child': {
      borderBottom: 'none',
    },

    '& .MuiAccordionSummary-root': {
      padding: '0px',
      minHeight: 'unset',

      '& .Mui-expanded': {
        marginBlock: theme.spacing(1),
      },
    },

    '&.Mui-expanded': {
      margin: '0px',
    },
  },
  filterAccordionSummary: {
    margin: `${theme.spacing(1)} 0px`,
  },
  filterAccordionDetails: {
    marginBlockEnd: theme.spacing(1),
    padding: '0px',
  },
  accordionFilterOptions: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1),

    '& .MuiCheckbox-root': {
      padding: 0,
      margin: 0,
    },

    '& .MuiFormControlLabel-root': {
      margin: 0,
    },
  },
  accordionFilterOptionsSingleColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),

    '& .MuiCheckbox-root': {
      padding: 0,
      margin: 0,
    },

    '& .MuiFormControlLabel-root': {
      margin: 0,
    },
  },
  nestedOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingInlineStart: theme.new.spacing.xl,
  },
  dropdownFilterOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),

    '& .MuiCheckbox-root': {
      padding: 0,
      margin: 0,
    },

    '& .MuiFormControlLabel-root': {
      margin: 0,
    },
  },
  checkbox: {
    '&.MuiCheckbox-root': {
      padding: 0,
      '& svg': {
        fill: theme.new.color.border,
        width: '20px',
        height: '20px',
      },
    },

    '&.Mui-checked': {
      '& .MuiSvgIcon-root': {
        fill: theme.new.color.brandPrimary,
      },
    },

    '&.MuiCheckbox-indeterminate': {
      '& .MuiSvgIcon-root': {
        fill: theme.new.color.brandPrimary,
      },
    },

    '&.Mui-focusVisible': {
      outline: `2px solid ${theme.new.color.brand[500]}`,
      outlineOffset: '2px',
      borderRadius: '4px',
    },
  },
}));

export default useStyles;
